import { Button } from '@material-ui/core';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const StyledCompany = styled.div`
  dl {
    display: flex;
    flex-wrap: wrap;
    line-height: 1.5rem;
  }

  dl dt {
    background-color: rgba(198, 158, 97, 0.5);
    width: 31%;
    font-weight: bold;
    padding: 2%;
    margin-bottom: 5px;
    display: flex;
    align-items: center;
  }

  dl dd {
    background-color: rgba(198, 158, 97, 0.2);
    width: 61%;
    padding: 2%;
    margin-bottom: 5px;
  }

  @media screen and (max-width: 751px) {
    dl dt,
    dl dd {
      width: 100%;
      padding: 10px;
    }

    dl dt {
      margin-bottom: 0px;
    }
  }

  .linkIndex {
    text-align: center;
    margin: 20px auto 0px auto;
  }
`;

/**
 * 運営会社についてページ
 */
const Company: FC = () => {
  return (
    <StyledCompany>
      <h2>運営会社について</h2>

      <dl>
        <dt>会社名</dt>
        <dd>一般社団法人 北海道国際流通機構</dd>

        <dt>住所</dt>
        <dd>
          〒060–0052
          <br />
          札幌市中央区南２条東1丁目1-12 フラーテ札幌4F
        </dd>

        <dt>ホームページ</dt>
        <dd>
          <a href="http://hi-do.or.jp/" target="_blank" rel="noreferrer">
            http://hi-do.or.jp/
          </a>
        </dd>
      </dl>
      <div className="linkIndex">
        <Button variant="contained" color="primary" component={Link} to="/">
          前のページへ戻る
        </Button>
      </div>
    </StyledCompany>
  );
};

export default Company;
